export const Images = {
  SUCCESS: require('./success.svg'),
  COUPONS: require('./coupons.svg'),
  METAMASK: require('./metaMask.svg'),
  CROSSMINT: require('./crossMint.svg'),
  WALLET_CONNECT: require('./walletConnect.svg'),
  ERROR: require('./error.svg'),
  MOJITO_LOGO: require('./mojitoLogo.svg'),
  GOOGLE: require('./google.svg')
};
